export default __webpack_public_path__ + "static/media/bootstarp.adde73ec.png";